export enum ProductStatusEnum {
    None = 0,
    Rejected = 1,
    Approved = 2
}
